"use strict";

var _interopRequireDefault = require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.string.starts-with.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.to-string.js");
var _Breadcrumb = _interopRequireDefault(require("@/components/Breadcrumb"));
var _Hamburger = _interopRequireDefault(require("@/components/Hamburger"));
var _LangSelect = _interopRequireDefault(require("@/components/LangSelect"));
var _localstorage = _interopRequireDefault(require("@/utils/localstorage"));
var _Screenfull = _interopRequireDefault(require("@/components/Screenfull"));
var _HeaderSearch = _interopRequireDefault(require("@/components/HeaderSearch"));
var _Login = _interopRequireDefault(require("@/api/Login.js"));
var _Msg = _interopRequireDefault(require("@/api/Msg.js"));
var _DepartmentInfo = _interopRequireDefault(require("@/api/DepartmentInfo.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    Breadcrumb: _Breadcrumb.default,
    Hamburger: _Hamburger.default,
    LangSelect: _LangSelect.default,
    Screenfull: _Screenfull.default,
    Search: _HeaderSearch.default
  },
  filters: {
    userAvatarFilter: function userAvatarFilter(name) {
      return name.charAt(0);
    },
    msgTypeFilter: function msgTypeFilter(status) {
      var map = {
        WAIT: "",
        NOTIFY: "success",
        PUBLICITY: "info",
        WARN: "danger"
      };
      return map[status] || "";
    }
  },
  data: function data() {
    return {
      tips: " 演示环境禁止修改、删除重要数据！请登录仓库【0000】，账号【wms_pt】查询其他仓库的管理员账号后，登录其他仓库测试全部功能!!! ",
      tableData: {
        total: 0,
        records: []
      },
      msgRefresh: _localstorage.default.get("MSG_REFRESH", false),
      // 消息是否自动刷新
      msgRefreshTimer: null
    };
  },
  computed: {
    sidebar: function sidebar() {
      return this.$store.state.setting.sidebar;
    },
    avatar: function avatar() {
      var user = this.$store.state.account.user;
      if (!user["avatar"]) {
        return require("@/assets/avatar/default.jpg");
      } else {
        if (user["avatar"].startsWith("http://") || user["avatar"].startsWith("https://")) {
          return user["avatar"];
        } else {
          return require("@/assets/avatar/".concat(user.avatar));
        }
      }
    },
    name: function name() {
      return this.$store.state.account.user.name;
    },
    userId: function userId() {
      return this.$store.state.account.user.id;
    },
    device: function device() {
      return this.$store.state.setting.device;
    }
  },
  mounted: function mounted() {
    this.tipsScrolling();
    // this.loadMyMsg();
    if (this.msgRefresh) {
      this.msgRefreshChange(true);
    }
    // 添加消息定时刷新
    this.msgRefreshTimer = setInterval(function () {
      // this.loadMyMsg();
    }, 600000);
  },
  methods: {
    // 演习模式
    exerciseMode: function exerciseMode() {
      this.$alert("因演习模式需要重新配置环境，如您想要开启演习模式，请联系浙江安澜应急科技有限公司，联系方式：15601891235。", "", {
        confirmButtonText: "确定"
        // callback: action => {
        //   this.$message({
        //     type: 'info',
        //     message: `action: ${ action }`
        //   });
        // }
      });
    },
    goScreen: function goScreen() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var isAdminPlate;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isAdminPlate = _localstorage.default.get("USER").isAdminPlate;
              if (isAdminPlate) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return _DepartmentInfo.default.checkMapJsonExit().then(function (res) {
                console.log(res.data.data);
                if (!res.data.data) {
                  _this.$message.error("请先配置地图数据！");
                  return false;
                } else {
                  _this.openScreen();
                }
              });
            case 4:
              _context.next = 7;
              break;
            case 6:
              _this.openScreen();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openScreen: function openScreen() {
      window.open(window.location.protocol + "/cockpit/#/autoLogin?token=" + _localstorage.default.get("TOKEN", "") + "&userId=" + _localstorage.default.get("USER", {
        id: null
      }).id);
    },
    goToMsg: function goToMsg() {
      this.$router.push({
        path: "/workbench/notice"
      });
    },
    tipsScrolling: function tipsScrolling() {
      var _this2 = this;
      setInterval(function () {
        //ES6箭头函数
        // 截取首字符串(第一个)
        var head = _this2.tips.substring(0, 1);
        // 截取除首字符串外所有字符串(除第一个所有)
        var foot = _this2.tips.substring(1);
        // 头尾拼接后赋给data => tit属性
        _this2.tips = foot + head;
      }, 1000);
    },
    loadMyMsg: function loadMyMsg() {
      var _this3 = this;
      var params = {
        model: {
          isRead: false
          // isAuthor:false
        }
      };

      params.size = 10;
      params.current = 1;
      params.model.status = false;
      params.model.isAuthor = false;
      _Msg.default.notifyList(params).then(function (response) {
        var res = response.data;
        if (res.isSuccess) {
          _this3.tableData = res.data;
        }
      });
      // msgApi.page(params, { isAlert: false }).then((response) => {
      //   const res = response.data;
      //   if (res.isSuccess) {
      //     this.tableData = res.data;
      //   }
      // });
    },
    mark: function mark(ids, callback) {
      _Msg.default.mark({
        msgCenterIds: ids
      }).then(function (response) {
        var res = response.data;
        if (typeof callback === "function") {
          callback(ids);
        }
      });
    },
    view: function view(row) {
      var _this4 = this;
      window.localStorage.setItem("wms_notice_detal", JSON.stringify(row));
      this.mark([row.id], function (ids) {
        _this4.loadMyMsg();
        _this4.$router.push({
          path: "/workbench/notice/detail",
          query: {
            id: row.id
          }
        });
      });
    },
    msgRefreshChange: function msgRefreshChange(val) {
      var _this5 = this;
      _localstorage.default.save("MSG_REFRESH", val);
      if (val) {
        this.msgRefreshTimer = setInterval(function () {
          _this5.loadMyMsg();
        }, 15000);
      } else {
        clearInterval(this.msgRefreshTimer);
        console.log("定时拉取消息停止了！");
        this.msgRefreshTimer = null;
      }
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.commit("setting/toggleSidebar");
    },
    setting: function setting() {
      this.$store.commit("setting/openSettingBar", true);
    },
    logout: function logout() {
      var _this6 = this;
      var param = {
        token: _localstorage.default.get("TOKEN", ""),
        userId: _localstorage.default.get("USER", {
          id: null
        }).id,
        clientId: process.env.VUE_APP_CLIENT_ID
      };
      _Login.default.logout(param).finally(function () {
        return _this6.clean();
      });
    },
    clean: function clean() {
      _localstorage.default.clear();
      location.reload();
    },
    deleteCache: function deleteCache() {
      var _this7 = this;
      this.$confirm(this.$t("tips.confirmDeleteCache"), this.$t("common.tips"), {
        confirmButtonText: this.$t("common.confirm"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(function () {
        _this7.reloadData();
      }).catch(function () {
        // do nothing
      });
    },
    reloadData: function reloadData() {
      var _this8 = this;
      var param = {
        grantType: "refresh_token",
        refreshToken: _localstorage.default.get("REFRESH_TOKEN", "")
      };
      _Login.default.login(param).then(function (response) {
        var res = response.data;
        if (res.isSuccess) {
          var data = res.data;
          console.log(data);
          _this8.$store.commit("account/setToken", data["token"]);
          _this8.$store.commit("account/setRefreshToken", data["refreshToken"]);
          _this8.$store.commit("account/setExpireTime", data["expiration"]);
          _this8.$store.commit("account/setUser", {
            id: data.userId,
            account: data.account,
            name: data.name,
            avatar: data.avatar,
            workDescribe: data.workDescribe,
            isAdminPlate: data.isAdminPlate
          });
          _this8.loadPermissions();
        } else {
          _this8.logout();
        }
      }).catch(function () {
        _localstorage.default.remove("EXPIRE_TIME");
        _localstorage.default.remove("TOKEN");
        _localstorage.default.remove("USER_ROUTER");
        _localstorage.default.remove("PERMISSIONS");
        _this8.logout();
      });
    },
    loadPermissions: function loadPermissions() {
      var _this9 = this;
      _Login.default.getResource().then(function (response) {
        var res = response.data;
        if (res.isSuccess) {
          var authorityResource = res.data;
          var permissionsList = authorityResource.resourceList || [];
          _this9.$store.commit("account/setPermissions", permissionsList);
          _this9.$store.commit("account/setAuthorityResource", authorityResource);
          setTimeout(function () {
            location.reload();
          }, 1000);
        } else {
          _this9.logout();
        }
      }).catch(function () {
        _this9.logout();
      });
    }
  }
};
exports.default = _default;